// Branded type for animation sequence identifiers
export type AnimationSequenceId = string & { readonly __brand: 'AnimationSequenceId' };

// Branded type for card position within a dealing batch (0-indexed)
export type CardIndexInBatch = number & { readonly __brand: 'CardIndexInBatch' };

export function createCardIndexInBatch(index: number): CardIndexInBatch {
  return index as CardIndexInBatch;
}

// Animation events that require client acknowledgment
export enum AnimationEvent {
  HAKEM_CARD_REVEAL = 'hakem_card_reveal',
  HAKEM_SELECTED = 'hakem_selected',
  PARTNER_SELECTED = 'partner_selected',
  SEATS_SWAPPED = 'seats_swapped',
  DEAL_BATCH = 'deal_batch',
  TRUMP_SELECTED = 'trump_selected',
  TRICK_COLLECTED = 'trick_collected',
  HAND_CLEARED = 'hand_cleared',
}

// Timeout values in milliseconds
export type AnimationTimeoutMs = number & { readonly __brand: 'AnimationTimeoutMs' };
